export const NAVIGATE_EVENT = 'page-navigate';

export interface NavigateEvent {
  url: string;
  previous: string | null;
}

export const CLICK_EVENT = 'click';

export interface ClickEvent {
  trigger: string;
  data: object;
}

export const SEARCH_EVENT = 'search';

export interface SearchEvent {
  trigger: string;
  data: object;
}

export const TOURGUIDE_EVENT = 'tour-guide';

export interface TourGuideEvent {
  action:
    'start' | 'complete' | 'cancel' | 'show' | 'next' | 'back' | undefined;
  tourName?: string;
  step?: string;
}

export const MEDIA_EVENT = 'media-event';
export interface MediaEvent {
  action: 'started' | 'ended' | 'paused' | 'resumed' | 'enlarged' | 'closed';
  type: 'video' | 'audio' | 'image' | 'media' | 'tts' | 'readspeaker';
  target?: string;
}

export const TOOL_USE_EVENT = 'tool-use';
export interface ToolUseEvent {
  action: 'used';
  target: string;
}

export const FEATURE_IMPRESSION_EVENT = 'feature-impression';
export interface FeatureImpressionEvent {
  featureName: string;
  variant: 'Control' | string;
  payload: Record<string, unknown>;
}

export type UserActivityEvent =
  | NavigateEvent
  | ClickEvent
  | MediaEvent
  | ToolUseEvent
  | SearchEvent
  | TourGuideEvent
  | FeatureImpressionEvent;
export type UserActivityEventType =
  | typeof NAVIGATE_EVENT
  | typeof CLICK_EVENT
  | typeof MEDIA_EVENT
  | typeof TOOL_USE_EVENT
  | typeof SEARCH_EVENT
  | typeof TOURGUIDE_EVENT
  | typeof FEATURE_IMPRESSION_EVENT;
